// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CineOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_2421_10200)","fill":"currentColor"},"children":[{"tag":"path","attrs":{"d":"M9.63 7.63v8.74L16.27 12 9.63 7.63z"}},{"tag":"path","attrs":{"d":"M19.6 4.23H4.4c-1.05 0-1.9.87-1.9 1.94v11.66c0 1.07.85 1.95 1.9 1.95h15.2c1.04 0 1.9-.88 1.9-1.95V6.17c0-1.07-.86-1.94-1.9-1.94zm0 13.61H4.4V6.16h15.2v11.68z"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_2421_10200"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"cine","theme":"outlined"};

const CineOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CineOutlinedSvg} />;
  CineOutlined.displayName = 'CineOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CineOutlined);
